import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('score_level')
export default class ScoreLevel {
  constructor() {
    this.name = undefined;
    this.explanation = undefined;
    this.notes = undefined;
    this.threshold = undefined;
    this.isShareTarget = undefined;
    this.isPositionResultTop = undefined;
    this.resourceUri = undefined;
    this.resourceFileName = undefined;
    this.alternativeText = undefined;
  }

  @JsonProperty('name')
  public name?: string;

  @JsonProperty('explanation')
  public explanation?: string;

  @JsonProperty('notes')
  public notes?: string;

  @JsonProperty('threshold')
  public threshold?: number;

  @JsonProperty('is_share_target')
  public isShareTarget?: boolean;

  @JsonProperty('is_position_result_top')
  public isPositionResultTop?: boolean;

  @JsonProperty('resource_uri', null, true)
  public resourceUri?: string;

  @JsonProperty('resource_file_name', null, true)
  public resourceFileName?: string;

  @JsonProperty('alternative_text', null, true)
  public alternativeText?: string;
}
